import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getDashboardCount } from "../redux/actions/DashboardActions";
import styled from "styled-components";
import { docUrl } from "../../axios";
import {
  Row,
  Col,
  Card,
  Table,
  Pagination,
  Button,
  Badge,
  Form,
  Modal,
} from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import {
  deleteCityData,
  getCityList,
  updateCityStatusData,
} from "../../redux/actions/CityActions";
import RoundedPagination from "../../Components/Paginate";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert2";
import { toast } from "react-toastify";
import { logout } from "../../redux/actions/AuthActions";
import useDebounce from "../../hooks/useDebounce";
import Preloader from "../../Components/Preloader";
import { getTripReportApprovalList, approveTripReport } from "../../redux/actions/TripReportActions";
import { getMasterAllUserList } from "../../redux/actions/MasterActions";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { CSVLink } from "react-csv";
import { apiURL } from "../../axios";
import Select from "react-dropdown-select";
import { addDays } from "date-fns";
import { getDisplayDateTimeFormat } from "../../util/generalUtills";

const TripReportApproval = () => {
  const { t } = useTranslation();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [editCityId, setEditCityId] = useState(null);
  const {
    AuthReducer: { auth, errors, loading },
    tripReportReducer: {
      tripReportPermissions,
      tripReportLists,
      loadingTripReport,
      errorsTripReport,
      tripReportCount,
      changedtripReportStatus,
    },
    masterReducer: { masterUserLists, loadingMaster, errorsMaster },
  } = useSelector((city) => city);
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(10);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("desc");
  const [month, setMonth] = useState(new Date());
  const indexOfLastItem = (page + 1) * paginate;
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const indexOfFirstItem = indexOfLastItem - paginate;
  const [readingImageUrl, setReadingImageUrl] = useState("");
  const [userId, setUserId] = useState("");
  const [formData, setFormData] = useState({
    userId: null,
    trip_start: null,
    trip_end: null,
  });
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [currentTripId, setCurrentTripId] = useState(null);

  useEffect(() => {
    console.log("tripReportLists", tripReportLists);
  }, [tripReportLists]);

  useEffect(() => {
    if (auth?.token) {
      dispatch(getMasterAllUserList(auth.token));
    }
  }, [auth?.token]);

  const handleImageClick = (userId,imageUrl) => {
    setUserId(userId);
    setReadingImageUrl(imageUrl);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setReadingImageUrl("");
    setUserId("");
  };

  const fetchTripList = useCallback(() => {
    if (auth?.token) {
      dispatch(
        getTripReportApprovalList(auth.token, paginate, page, search, sort, formData)
      );
    }
  }, [auth, paginate, page, search, sort, dispatch]);

  useDebounce(fetchTripList, 500, [auth, paginate, page, search, sort]);

  const csvHead = [
    [
      "SR No.",
      "Name",
      "Contact Number",
      "User Type",
      "Total Days",
      "Total Working",
      "Total Week Off",
      "Total Half Days",
      "Total Leave",
      "Total W.F.H",
      "Total Sunday Working",
      "Total Absent",
    ],
  ];
  //   const csvData = tripReportLists?.map((cv, index) => {
  //     const totalMonth = new Date(
  //       month.getFullYear(),
  //       parseInt(month.getMonth()) + 1,
  //       0
  //     ).getDate();
  //     return [
  //       index + 1,
  //       cv?.name,
  //       cv?.phone || "",
  //       cv?.user_type || "",
  //       totalMonth || "0",
  //       cv?.Total_working_days || "0",
  //       cv?.Total_weak_off_days || "0",
  //       cv?.Total_half_days || "0",
  //       cv?.Total_leave_days || "0",
  //       cv?.Total_wfh_days || "0",
  //       cv?.Total_sunday_working_days || "0",
  //       cv?.Total_absent_days || "0",
  //     ];
  //   });
  //   const exportData = csvHead.concat(csvData);

  useEffect(() => {
    if (errors) {
      if (errors?.status == 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate("/login");
        window.location.reload();
      }
    }
  }, [errors]);

  const handlePaginateChange = (e) => {
    const value =
      e.target.value === "All" ? tripReportCount : parseInt(e.target.value);
    setPaginate(value);
    setPage(1); // Reset to the first page whenever the paginate value changes
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const selectHandler = (selectedData, name) => {
    console.log(selectedData);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: selectedData[0]?.id,
    }));
  };
  useEffect(() => {
    document.title = `Trip Report Approval :: ${auth?.generalSettings?.title}`;
  }, []);

  const printTable = () => {
    const printWindow = window.open("", "", "height=600,width=800");
    printWindow.document.write(`<html><head><style type="text/css">'+
      '#backgroundImage{'+
        'min-height: 50vh;'+
        'position: relative;'+
        'margin: 0;'+
        '-webkit-print-color-adjust: exact !important; '+
        'color-adjust: exact !important;'+
        '}'+
        '#backgroundImage:before {'+
        'content: "";'+
        'position: absolute;'+
        'z-index: -1;'+
        'top: 0;'+
        'bottom: 0;'+
        'left: 0;'+
        'right: 0;'+
        'opacity: 0.04;'+
        'background:'+
            'url(\'${apiURL}logo.jpg\')'+
        '}'+
        '</style></head><body onload="window.print()" id="backgroundImage"><div align="center ">'+document.title+'</div><div class="main1"><table border="1" cellspacing="0">`);
    printWindow.document.write(
      document.getElementById("table-to-print").innerHTML
    );
    printWindow.document.write(
      '</table></div><div align="center">This is a system generated report it does not require any signature or stamp</div><div align="right"><img src="logo.jpg" style="opacity: 0.1"></div></body></html>'
    );
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const formatDateToLocalString = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleSearchClick = () => {
    const formattedData = {
      ...formData,
      trip_start: formatDateToLocalString(formData.trip_start),
      trip_end: formatDateToLocalString(formData.trip_end),
    };
    console.log("formData", formattedData);
    dispatch(getTripReportApprovalList(auth.token, paginate, page, search, sort, formattedData));
  };

  const handleSearchClear = () => {
    setFormData({
      userId: null,
      trip_start: null,
      trip_end: null,
    });
    setDateRange([null, null]);
    dispatch(
      getTripReportApprovalList(auth.token, paginate, page, search, sort, {
        userId: null,
        trip_start: null,
        trip_end: null,
      })
    );
  };

  const handleApproveClick = (id) => {
    swal.fire({
      title: "Are you sure?",
      text: "Do you want to approve this trip report?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          trip_id: id,
          status: "Approved",
          reject_remark: "null",
        };
        dispatch(approveTripReport(auth.token, payload));
      }
    });
  };

  const handleRejectClick = (id) => {
    setCurrentTripId(id);
    setRejectReason("");
    setShowRejectModal(true);
  };

  const handleRejectModalClose = () => {
    setShowRejectModal(false);
    setRejectReason("");
    setCurrentTripId(null);
  };

  const handleRejectSubmit = () => {
    if (!rejectReason.trim()) {
      swal.fire({
        icon: "error",
        title: "Error",
        text: "Please enter rejection reason",
      });
      return;
    }
    const payload = {
      trip_id: currentTripId,
      status: "Reject",
      reject_remark: rejectReason,
    };
    dispatch(approveTripReport(auth.token, payload));
    handleRejectModalClose();
  };

  useEffect(() => {
    if (changedtripReportStatus?.success || changedtripReportStatus?.status) {
      const message = changedtripReportStatus?.message || 'Trip report processed successfully';
      swal.fire({
        show: true,
        title: "Success!",
        text: message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_APPROVE_TRIP_REPORT_STATUS' });
      if (auth?.token) {
        dispatch(
          getTripReportApprovalList(auth.token, paginate, page, search, sort, formData)
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changedtripReportStatus]);

  

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          {
            label: t("Attendance Report"),
            path: "/Attendance/TripReportApproval",
            active: false,
          },
          {
            label: t("Trip Report Approval"),
            path: "/Attendance/TripReportApproval",
            active: true,
          },
        ]}
        title={t("Trip Report Approval")}
      />

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div className="mb-2">
                <Row>
                  {/* {tripReportPermissions.filter && ( */}
                  <>
                    <Col lg={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          {t("User")}{" "}
                          <span style={{ color: "red", fontSize: 15 }}>*</span>
                        </Form.Label>
                        <Select
                          options={masterUserLists}
                          values={masterUserLists?.filter(
                            (user) => user?.id === formData?.userId
                          )}
                          name="userId"
                          labelField={"name"}
                          //clearable={true}
                          valueField={"id"}
                          loading={loadingMaster}
                          searchBy="name"
                          onChange={(selectedData) =>
                            selectHandler(selectedData, "userId")
                          }
                          //styles={customSelectStyles}
                        />
                      </Form.Group>
                    </Col>
                  </>
                  {/* )} */}
                  <Col lg={3}>
                    {/* {tripReportPermissions.filter && ( */}
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Date")}</Form.Label>
                      <DatePicker
                        selectsRange={true}
                        dateFormat="yyyy-MM-dd"
                        startDate={startDate}
                        endDate={endDate}
                        todayButton="Today"
                        showMonthDropdown
                        showYearDropdown
                        //isClearable={true}
                        dropdownMode="select"
                        className="form-control"
                        onChange={(update) => {
                          setDateRange(update);
                          console.log("update", update);
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            trip_start: update[0],
                            trip_end: update[1] || update[0],
                          }));
                        }}
                        withPortal
                      />
                    </Form.Group>
                    {/* )} */}
                  </Col>
                  <Col lg={3}>
                    {(formData.userId ||
                      formData.trip_start ||
                      formData.trip_end ||
                      endDate ||
                      startDate) && (
                      <div
                        className="d-flex gap-2"
                        style={{ marginTop: "28px" }}
                      >
                        <Button variant="success" onClick={handleSearchClick}>
                          {t("Search")}
                        </Button>
                        <Button variant="danger" onClick={handleSearchClear}>
                          {t("Clear all")}
                        </Button>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>

              <div
                style={{
                  overflowY: "auto",
                  maxHeight: "500px",
                  border: "1px solid #dee2e6",
                }}
              >
                <Table
                  className="mb-0 table-bordered"
                  id="table-to-print"
                  size="sm"
                  striped
                  responsive
                >
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      backgroundColor: "#f8f9fa",
                      zIndex: 1,
                    }}
                  >
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>User Type</th>
                      <th>Start Date and Time</th>
                      <th>Start Address</th>
                      <th>Start Readings</th>
                      <th>End Date and Time</th>
                      <th>End Address</th>
                      <th>End Readings</th>
                      <th>Start Readings Photo</th>
                      <th>End Readings Photo</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tripReportLists?.length === 0 ? (
                      <tr>
                        <td colSpan="12">No data found</td>
                      </tr>
                    ) : (
                      <>
                        {tripReportLists?.map?.((item, index) => {
                          return (
                            <tr key={item.id}>
                              <th scope="row">
                                {index + 1 + (page - 1) * paginate}
                              </th>
                              <td>{item?.userTrip?.name}</td>
                              <td>{item?.userTrip?.phone}</td>
                              <td>{item?.userTrip?.adminUserType?.name}</td>
                              <td>{getDisplayDateTimeFormat(item?.start_time)}</td>
                              <td>{item?.start_address}</td>
                              <td>{item?.start_reading}</td>
                              <td>{getDisplayDateTimeFormat(item?.end_time)}</td>
                              <td>{item?.end_address}</td>
                              <td>{item?.end_reading}</td>
                              <td>
                                {item?.start_reading_img != null ? (
                                  <img
                                    className="avatar-md rounded"
                                    src={`${docUrl}/uploads/trip/${item?.user_id}/${item?.start_reading_img}`}
                                    onClick={() => handleImageClick(item?.user_id,item?.start_reading_img)}
                                    alt="Start Reading Image"
                                  />
                                ) : (
                                  ""
                                )}
                              </td>
                              <td>
                                {item?.end_reading_img != null ? (
                                  <img
                                    className="avatar-md rounded"
                                    src={`${docUrl}/uploads/trip/${item?.user_id}/${item?.end_reading_img}`}
                                    onClick={() => handleImageClick(item?.user_id,item?.end_reading_img)}
                                    alt="End Reading Image"
                                  />
                                ) : (
                                  ""
                                )}
                              </td>
                              <td className="d-flex gap-2 justify-content-center">
                                {(item?.end_reading) ? (
                                  <>
                                <Button variant="success" size="md" onClick={() => handleApproveClick(item?.id)}>Approve
                                </Button>
                                <Button variant="danger" size="md" onClick={() => handleRejectClick(item?.id)}>Reject
                                </Button>
                                </>
                                ):(<Badge className='bg-warning'>
                                  {`Trip Pending`}
                                </Badge>)}
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    )}
                  </tbody>
                </Table>
              </div>
              <div class="mt-3 d-lg-flex align-items-center text-center pb-1">
                <div class="d-inline-block me-3">
                  <label class="me-1">Display :</label>
                  <select
                    class="form-select d-inline-block w-auto"
                    onChange={handlePaginateChange}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <span class="me-3">
                  Page <strong>{page}</strong> of{" "}
                  <strong>{Math.ceil(tripReportCount / paginate)}</strong>{" "}
                </span>
                <RoundedPagination
                  currentPage={page}
                  totalPages={Math.ceil(tripReportCount / paginate)}
                  onPageChange={(pageNumber) => setPage(pageNumber)}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal show={showModal} onHide={handleClose} size="md">
        <Modal.Body>
          <img
            src={`${docUrl}/uploads/trip/${userId}/${readingImageUrl}`}
            alt="Full size"
            className="img-fluid"
          />
        </Modal.Body>
      </Modal>

      <Modal show={showRejectModal} onHide={handleRejectModalClose} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Reject Trip Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>
              Rejection Reason <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Enter rejection reason..."
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleRejectModalClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleRejectSubmit}>
            Submit Rejection
          </Button>
        </Modal.Footer>
      </Modal>

      {loadingTripReport && <Preloader />}
    </>
  );
};

export default TripReportApproval;
